<template>
  <div class="basic-job-wrapper">
    <div class="tooptipPart module_edit_btn">
      <my_edit_btn :module="module"></my_edit_btn>
      <template v-if="$store.state.app.view_pattern === 'pc'">
        <my_edit_btn :module="module" tabName="animation"></my_edit_btn>
        <my_close_btn :module="module" :column="column" :moduleIndex="module_index"></my_close_btn>
      </template>
    </div>
    <my_title_index :title="infor.title"></my_title_index>
    <div class="data_empty" v-if="!listArr.jobs.length">
      <i class="empty_tips_img"></i>
      <div class="empty_tips_text">{{$t('widgets_basic_job_index_2528')}}</div>
      <div class="btn_group">
        <el-button type="primary" size="medium" @click="changeStyle('style')">{{$t('components_my_add_button_index_2217')}}</el-button>
      </div>
    </div>
    <template v-else>
      <div v-if="Number(listArr.module_style)===1" class="module-style-1">
        <div class="el-table">
          <div cellspacing="0" cellpadding="0" border="0" class="my-mock-table el-table__header" width="100%"
               :style="borderSpacingStyle">
            <div class="my-mock-thead has-gutter">
              <div class="my-mock-tr" :style="splitLineStyle">
                <div colspan="1" rowspan="1"
                     class="my-mock-th el-table_1_column_1 undefined el-table__expand-column  is-leaf">
                  <div class="cell"></div>
                </div>
                <div
                  v-for="item in filteredTableConfig"
                  colspan="1"
                  rowspan="1"
                  :key="item.value"
                  :class="['my-mock-th','el-table_1_column_2 is-leaf','th-'+item.value]">
                  <div :class="['cell','cell-'+item.value]" :style="{...labelFontStyle,...getColWidthStyle(item)}">
                    {{ item.label }}
                  </div>
                </div>
              </div>
            </div>
            <div class="my-mock-tbody">
              <template v-for="job in jobList">
                <div class="my-mock-tr el-table__row job-table-row"
                     :style="{...job.isHover?getBackground('selected'):getBackground('default'),...splitLineStyle}"
                     @mouseenter="onMouseEnterJob(job)"
                     @mouseleave="onMouseLeaveJob(job)"
                     @click="onClickExpandIcon">
                  <div rowspan="1" colspan="1"
                       class="my-mock-td el-table_3_column_13  undefined el-table__expand-column">
                    <div class="cell">
                      <!--                      <div class="el-table__expand-icon"><i class="el-icon el-icon-arrow-right"></i></div>-->
                      <div class="el-table__expand-icon"><i class="fa fa-angle-right"></i></div>
                    </div>
                  </div>
                  <div v-for="item in filteredTableConfig"
                       :key="item.value"
                       rowspan="1"
                       colspan="1"
                       :class="['my-mock-td','el-table_3_column_14','td-'+item.value]">
                    <div :class="['cell', 'cell-'+item.value]"
                         :style="{...contentFontStyle,...paddingStyle}">
                      <span v-if="item.value==='endTime' && !job.endTime">{{$t('widgets_basic_job_index_2529')}}</span>
                      <span v-else-if="item.value==='num' && job.num==0">{{$t('widgets_basic_job_index_2530')}}</span>
                      <span v-else-if="item.value==='num' && job.num!=0">{{$t('widgets_basic_job_index_2531', [ job.num ])}}</span>
                      <span v-else>{{ job[item.value] }}</span>
                    </div>
                  </div>
                </div>
                <div class="my-mock-tr el-table__expanded-cell my-job-expended-cell" :style="splitLineStyle">
                  <div class="my-mock-td" :colspan="filteredTableConfig.length+1">
                    <div class="job-detail-wrapper">
                      <h2 class="job-title">{{ job.subject }}</h2>
                      <div class="job-item">
                        <div class="item-label" :style="labelFontStyle">{{$t('widgets_basic_job_index_2532')}}</div>
                        <div class="item-content" :style="contentFontStyle" v-html="job.content"></div>
                      </div>
                      <div class="job-item">
                        <div class="item-label" :style="labelFontStyle">{{$t('widgets_basic_job_index_2533')}}</div>
                        <div class="item-content" :style="contentFontStyle" v-html="job.require"></div>
                      </div>
                      <div class="job-item">
                        <div class="item-label" :style="labelFontStyle">{{$t('widgets_basic_job_index_2534')}}</div>
                        <div class="item-content" :style="contentFontStyle">{{ job.address }}</div>
                      </div>
                      <div class="job-item">
                        <div class="item-label" :style="labelFontStyle">{{$t('widgets_basic_job_index_2535')}}</div>
                        <div class="item-content" :style="contentFontStyle">{{ job.jobType }}</div>
                      </div>
                      <div class="job-item">
                        <div class="item-label" :style="labelFontStyle">{{$t('widgets_basic_job_index_2536')}}</div>
                        <div class="item-content" :style="contentFontStyle">{{ job.salary }}</div>
                      </div>
                      <div class="job-item">
                        <div class="item-label" :style="labelFontStyle">{{$t('widgets_basic_job_index_2537')}}</div>
                        <div class="item-content" :style="contentFontStyle">
                          <span v-if="!job.endTime" class="item-content-time no-endtime">{{$t('widgets_basic_job_index_2529')}}</span>
                          <span v-else class="item-content-time">{{ job.endTime }}</span>
                        </div>
                      </div>
                      <div class="job-item row-btn">
                        <el-button type="primary" size="small" @click="onClickSubmitBtn(job)">{{$t('widgets_basic_job_index_2538')}}</el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div v-if="Number(listArr.module_style)===2" class="module-style-2">
        <div class="job-overview-panel"
             :style="isHoverObj.isHover?getBackground('selected'):getBackground('default')"
             @mouseenter="onMouseEnterJob(isHoverObj)"
             @mouseleave="onMouseLeaveJob(isHoverObj)">
          <div class="panel-title">{{$t('widgets_basic_job_index_2539')}}</div>
          <div class="panel-content">
            <el-tag v-for="job in jobList" :key="job.id" size="small" class="job-tag">{{job.subject}}({{
                Number(job.num) ? $t('widgets_basic_job_index_2531', [job.num]) : $t('widgets_basic_job_index_2530')
            }})
            </el-tag>
          </div>
        </div>
        <div class="job-list"
             :style="heightStyle">
          <div class="job-detail-wrapper" v-for="job in jobList" :key="job.id">
            <h2 class="job-title">{{ job.subject }}</h2>
            <div class="job-item">
              <div class="item-label" :style="labelFontStyle">{{$t('widgets_basic_job_index_2532')}}</div>
              <div class="item-content" :style="contentFontStyle" v-html="job.content"></div>
            </div>
            <div class="job-item" v-if="listArr.field.includes('require')">
              <div class="item-label" :style="labelFontStyle">{{$t('widgets_basic_job_index_2533')}}</div>
              <div class="item-content" :style="contentFontStyle" v-html="job.require"></div>
            </div>
            <div class="job-item" v-if="listArr.field.includes('address')">
              <div class="item-label" :style="labelFontStyle">{{$t('widgets_basic_job_index_2534')}}</div>
              <div class="item-content" :style="contentFontStyle">{{ job.address }}</div>
            </div>
            <div class="job-item" v-if="listArr.field.includes('jobType')">
              <div class="item-label" :style="labelFontStyle">{{$t('widgets_basic_job_index_2535')}}</div>
              <div class="item-content" :style="contentFontStyle">{{ job.jobType }}</div>
            </div>
            <div class="job-item" v-if="listArr.field.includes('salary')">
              <div class="item-label" :style="labelFontStyle">{{$t('widgets_basic_job_index_2536')}}</div>
              <div class="item-content" :style="contentFontStyle">{{ job.salary }}</div>
            </div>
            <div class="job-item" v-if="listArr.field.includes('endTime')">
              <div class="item-label" :style="labelFontStyle">{{$t('widgets_basic_job_index_2537')}}</div>
              <div class="item-content" :style="contentFontStyle">
                <span v-if="!job.endTime" class="item-content-time no-endtime">{{$t('widgets_basic_job_index_2529')}}</span>
                <span v-else class="item-content-time">{{ job.endTime }}</span>
              </div>
            </div>
            <div class="job-item row-btn">
              <el-button type="primary" size="small" @click="onClickSubmitBtn(job)">{{$t('widgets_basic_job_index_2538')}}</el-button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import i18n from '../../language/index'

import {
  getJobList,
  getResumeColumn
} from "@/api/app.js";
import table1 from "./components/table1";
import table2 from "./components/table2";
import table3 from "./components/table3";
import table4 from "./components/table4";

import Vue from 'vue';

export default {
  name: "basic_job",
  components: {
    table1,
    table2,
    table3,
    table4,
  },
  data() {
    return {
      jobList: [],
      tableConfig: [{
        value: 'subject',
        label: i18n.t('widgets_basic_job_index_2541')
      }, {
        value: 'address',
        label: i18n.t('base_options_config_1845')
      }, {
        value: 'jobType',
        label: i18n.t('base_options_config_1846')
      }, {
        value: 'salary',
        label: i18n.t('base_options_config_1847')
      }, {
        value: 'require',
        label: i18n.t('base_options_config_1848')
      }, {
        value: 'num',
        label: i18n.t('widgets_basic_job_index_2542')
      }, {
        value: 'endTime',
        label: i18n.t('base_options_config_1849')
      }],
      isHoverObj: {
        isHover: false
      },
      heightStyle: {},
      tableVisible: {
        1: false,
        2: false,
        3: false,
        4: false,
      },
      resumeColumn: null,
      preventFast: false
    }
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    infor() {
      return this.module.data[this.$store.state.app.view_pattern + '_widgets_infor']
    },
    pc_widgets_infor() {
      return this.module.data.pc_widgets_infor
    },
    mb_widgets_infor() {
      return this.module.data.mb_widgets_infor
    },
    listArr() {
      return this.module.data.listArr
    },
    filteredTableConfig() {
      if (this.$store.state.app.view_pattern === 'mb') {
        return this.mbFilteredTableConfig
      } else {
        return this.pcFilteredTableConfig
      }
    },
    pcFilteredTableConfig() {
      return this.tableConfig.filter((item) => {
        return (this.listArr.field.includes(item.value) || item.value === 'subject' || item.value === 'num') && (item.value !== 'require')
      })
    },
    mbFilteredTableConfig() {
      return this.pcFilteredTableConfig.filter((item) => {
        return item.value === 'subject' || item.value === 'salary'
      })
    },
    labelFontStyle() {
      let fontStyle = {}
      let font = this.pc_widgets_infor.field_label[this.pc_widgets_infor.field_label.radio_val]
      fontStyle.fontSize = font.fontSize + 'px'
      fontStyle.fontFamily = font.fontFamily
      fontStyle.lineHeight = this.defaultLineHeight || 1
      fontStyle.textDecoration = font.fontUnderline
      fontStyle.fontWeight = font.fsWeight
      fontStyle.fontStyle = font.fsItalics

      if (font.pattern == 'linear_gradient') {
        fontStyle.webkitBackgroundClip = 'text'
        fontStyle.webkitTextFillColor = 'transparent'
        fontStyle.color = ''
        fontStyle.backgroundImage = 'linear-gradient(' + font.linear_gradient.deg + 'deg,' + font.linear_gradient.start_color +
          font.linear_gradient.start_pointer + '%,' + font.linear_gradient.end_color + font.linear_gradient.end_pointer +
          '%)'
      } else {
        fontStyle.color = font.fontColor
      }
      return fontStyle
    },
    contentFontStyle() {
      let fontStyle = {}
      let font = this.pc_widgets_infor.field_content[this.pc_widgets_infor.field_content.radio_val]
      fontStyle.fontSize = font.fontSize + 'px'
      fontStyle.fontFamily = font.fontFamily
      fontStyle.lineHeight = this.defaultLineHeight || 1
      fontStyle.textDecoration = font.fontUnderline
      fontStyle.fontWeight = font.fsWeight
      fontStyle.fontStyle = font.fsItalics
      if (font.pattern == 'linear_gradient') {
        fontStyle.webkitBackgroundClip = 'text'
        fontStyle.webkitTextFillColor = 'transparent'
        fontStyle.color = ''
        fontStyle.backgroundImage = 'linear-gradient(' + font.linear_gradient.deg + 'deg,' + font.linear_gradient.start_color +
          font.linear_gradient.start_pointer + '%,' + font.linear_gradient.end_color + font.linear_gradient.end_pointer +
          '%)'
      } else {
        fontStyle.color = font.fontColor
      }
      return fontStyle
    },
    splitLineStyle() {
      let infor = this.pc_widgets_infor
      return {
        borderBottom: `${infor.splitLine[infor.splitLine.radio_val].borderWidth}px ${infor.splitLine[infor.splitLine.radio_val].borderStyle} ${infor.splitLine[infor.splitLine.radio_val].borderColor}!important`,
      }
    },
    borderSpacingStyle() {
      let infor = this.pc_widgets_infor
      return {
        borderSpacing: `${infor.splitLine[infor.splitLine.radio_val].borderWidth}px`
      }
    },
    paddingStyle() {
      let pc_infor = this.pc_widgets_infor
      if (!pc_infor.padding[pc_infor.padding.radio_val].value) {
        return {}
      }
      return {
        paddingTop: pc_infor.padding[pc_infor.padding.radio_val].value + 'px',
        paddingBottom: pc_infor.padding[pc_infor.padding.radio_val].value + 'px',
      }
    }
  },
  watch: {
    'listArr.jobs'() {
      this.getJobList().then(() => {
        this.getHeightStyle()
      })
    },
    'pc_widgets_infor.contentHeight': {
      handler() {
        this.getHeightStyle()
      },
      deep: true
    },
    'listArr.module_style'() {
      setTimeout(() => {
        this.getHeightStyle()
      })
    }
  },
  methods: {
    init() {
      if (this.listArr.jobs.length) {
        this.getJobList().then(() => {
          this.getHeightStyle()
          if (this.jobList.length !== this.listArr.jobs.length) {
            // 删除状态是关闭的id，不删的话，编辑弹窗的拖动排序会有问题
            this.listArr.jobs = this.jobList.map(j => j.id)
          }
        })
      }
    },
    changeStyle(tabName) {
      this.templet.changeStyle(this.module, tabName)
    },
    onClickExpandIcon(e) {
      let $icon = $(e.target).hasClass('fa') ? $(e.target) : $(e.currentTarget).find('.fa');

      if ($icon.hasClass('fa-angle-right')) {
        $icon.removeClass('fa-angle-right')
        $icon.addClass('fa-angle-down')
        $icon.parents('.el-table__row').next().show()
      } else {
        $icon.removeClass('fa-angle-down')
        $icon.addClass('fa-angle-right')
        $icon.parents('.el-table__row').next().hide()
      }
    },
    onMouseEnterJob(job) {
      job.isHover = true
    },
    onMouseLeaveJob(job) {
      job.isHover = false
    },
    getJobList() {
      return getJobList({
        ids: this.listArr.jobs.join(','),
        rows: 999
      }).then(res => {
        res.data.data.forEach(d => {
          d.isHover = false;
          d.content = (d.content || '').replace(/\r?\n/g, '<br />');
          d.require = (d.require || '').replace(/\r?\n/g, '<br />');
        })
        this.jobList = res.data.data
      })
    },
    getBackground(type = 'default') {
      //type有default和selected两种值
      let background = this.pc_widgets_infor.background
      let style = {}
      if (type === 'default') {
        let pattern = background[background.radio_val].pattern
        style.backgroundColor = background[background.radio_val].color
        if (pattern === 'linear_gradient') {
          let linear_gradient = background[background.radio_val].linear_gradient
          style.backgroundImage =
            'linear-gradient(' +
            linear_gradient.deg +
            'deg,' +
            linear_gradient.start_color +
            linear_gradient.start_pointer +
            '%,' +
            linear_gradient.end_color +
            linear_gradient.end_pointer +
            '%)';
        }
      } else if (type === 'selected') {
        let pattern = background[background.radio_val].sePattern
        style.backgroundColor = background[background.radio_val].seColor
        if (pattern === 'linear_gradient') {
          let linear_gradient = background[background.radio_val].seLinearGradient
          style.backgroundImage =
            'linear-gradient(' +
            linear_gradient.deg +
            'deg,' +
            linear_gradient.start_color +
            linear_gradient.start_pointer +
            '%,' +
            linear_gradient.end_color +
            linear_gradient.end_pointer +
            '%)';
        }
      }
      return style
    },
    getColWidthStyle(item) {
      if (item.value === 'endTime') {
        let contentFont = this.pc_widgets_infor.field_content[this.pc_widgets_infor.field_content.radio_val].fontSize
        return {
          width: parseInt(contentFont) * 12 + 'px'
        }
      }
      return {}
    },
    getHeightStyle() {
      let pc_widgets_infor = this.pc_widgets_infor
      if (pc_widgets_infor.contentHeight.radioVal === 'custom') {
        this.heightStyle = {
          height: pc_widgets_infor.contentHeight[pc_widgets_infor.contentHeight.radioVal].height
        }
      } else {
        // 默认显示4条
        let $list = $(`#u${this.module.widgets_id} .job-list .job-detail-wrapper`)
        if (this.jobList.length <= 3) {
          this.heightStyle = {
            height: 'auto'
          }
        } else {
          this.heightStyle = {
            height: ($list.eq(0).outerHeight() + $list.eq(1).outerHeight() + $list.eq(2).outerHeight() + $list.eq(3).outerHeight()) + 'px'
          }
        }
      }
    },
    onClickSubmitBtn(job) {
      if (this.preventFast) {
        return
      }
      this.preventFast = true
      setTimeout(() => {
        this.preventFast = false
      }, 1000)

      if (this.isExpired(job)) {
        return this.$message.info(i18n.t('widgets_basic_job_index_2543'))
      }

      if (this.resumeColumn) {
        this.showTableDialog(job)
      } else {
        this.getResumeColumn().then(() => {
          this.showTableDialog(job)
        })
      }
    },
    isExpired(job) {
      if (!job.endTime) {
        return false
      }
      return new Date(job.endTime).getTime() < new Date().getTime()
    },
    showTableDialog(job) {
      let constructorMap = {
        1: table1,
        2: table2,
        3: table3,
        4: table4,
      }
      let map = {
        1: 'first',
        2: 'second',
        3: 'third',
        4: 'fourth',
      }

      let styleType = job.style_type
      let labelMap = this.resumeColumn[map[styleType]]
      let tableConstructor = constructorMap[styleType]
      let Table = Vue.extend(tableConstructor)
      let instance = new Table({
        data: {
          widgetId: this.module.widgets_id,
          labelMap: labelMap
        }
      })
      let vm = instance.$mount()
      document.querySelector('#app_child_frame').appendChild(vm.$el)
      this.$nextTick(() => {
        this.updateTable(vm.$el, job)
      })

    },
    closeTableDialog(name) {
      this.tableVisible[name] = false
    },
    getResumeColumn() {
      return getResumeColumn().then(res => {
        this.resumeColumn = res.data
      })
    },
    updateTable(elTable, job) {
      let styleType = job.style_type
      let $wrapper = $(elTable)
      let map = {
        1: 'first',
        2: 'second',
        3: 'third',
        4: 'fourth',
      }
      let labelMap = this.resumeColumn[map[styleType]]
      for (let key in labelMap) {
        $wrapper.find(`.table-${styleType}`).find(`.label-${key}`).html(labelMap[key])
      }
      $wrapper.find('.form-tip-job').html(i18n.t('widgets_basic_job_components_table1_2521') + job.subject)
      $wrapper.find('.dialog_title .title').html(job.subject)
    }
  },
  created() {
    this.init()
  },
  mounted() {

  }
}
</script>

<style lang="scss" scoped>
.basic-job-wrapper {
  .data_empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 90px 0;

    .empty_tips_img {
      display: block;
      width: 157px;
      height: 123px;
      margin: 0 auto 28px;
      background: url(~@/assets/image/default_icon.png) 0 0;
    }

    .empty_tips_text {
      margin-top: 28px;
      font-size: 16px;
      line-height: 24px;
      color: #333;
      text-align: center;
    }

    .btn_group {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin-top: 20px;

      /deep/ .el-button {
        margin: 10px 15px;
      }
    }
  }

  .no-endtime {
    color: #ff0000;
  }

  .my-job-expended-cell:hover {
    background: #f5f7fa !important;
  }

  .job-detail-wrapper {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 10px;
    padding-right: 10px;

    &:hover {
      background: #f5f7fa;
    }

    .job-title {
      margin-bottom: 5px;
    }

    .row-btn {
      margin-top: 5px;
    }
  }

  .job-item {
    line-height: 1.5;
    padding-top: 4px;
    padding-bottom: 4px;

    .item-label, .item-content {
      display: inline-block;
      vertical-align: top;
    }
  }

  .job-table-row {
    .cell {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .module-style-1 .job-detail-wrapper {
    padding-left: 50px;
  }

  .my-mock-tr.my-job-expended-cell.el-table__expanded-cell {
    display: none;
  }


  .job-overview-panel {
    display: flex;
    align-items: flex-start;
    border: 1px solid #ddd;
    padding: 10px;
    padding-bottom: 0;
  }

  .panel-title {
    font-size: 20px;
    padding-left: 0;
    margin-right: 10px;
  }

  .panel-content {
    flex: 1;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .job-tag {
    margin-right: 10px;
    margin-bottom: 10px;
  }

  .module-style-2 {
    .job-list {
      border-left: 1px solid #ddd;
      border-right: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
      overflow-y: auto;
    }

    .job-detail-wrapper {
      padding-top: 10px;
      padding-bottom: 10px;
      border-bottom: 1px solid #ddd;
      padding-left: 10px;
    }
  }

  .my-mock-tr {
    display: flex;
  }

  .my-mock-th, .my-mock-td {
    .cell {
      padding-left: 10px;
      padding-right: 0;
    }
  }

  .my-mock-thead {
    .cell {
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }

  .el-table__expand-column {
    width: 40px;
    flex-shrink: 0;
  }

  .el-table__expand-column .cell {
    display: flex;
    height: 100%;
    align-items: center;
    padding-left: 0;
    justify-content: center;
  }

  .el-table__expand-icon {
    font-size: 20px;
    height: 20px;
    color: #999;
  }

  .th-subject, .td-subject {
    flex: 1;
    overflow: hidden;
    flex: 3 1 300px;
  }

  .th-address, .td-address {
    flex: 1 0 100px;
  }

  .th-jobType, .td-jobType {
    width: 110px;
    flex-grow: 1;
  }

  .th-salary, .td-salary {
    width: 110px;
    flex-grow: 1;
  }

  .th-num, .td-num {
    flex: 1 0 100px;
  }

  .th-endTime, .td-endTime {
    flex: 1 0 180px;
  }

  .cell-endTime {
    width: 12em;
  }

  .el-table__expanded-cell {
    padding: 0;
  }
}

.mb_pattern {
  .basic-job-wrapper {

    .module-style-1 {
      .th-salary, .td-salary {
        width: 100px;
        flex-shrink: 0;
      }
    }

    .module-style-2 .job-list {
      height: auto !important;
    }

    .panel-title {
      width: 2em;
    }

  }

}
</style>
<style lang="scss">
.basic-job-wrapper {
  .el-table {
    th {
      //border-bottom: none !important;
    }

    td {
      //border-bottom: none !important;
      padding: 0;
    }

    table {
      border-collapse: separate;
    }

    &::before {
      display: none;
    }
  }

  .el-table__expand-icon > .el-icon {
    position: relative;
    top: 0;
    left: 0;
    margin-left: 0px;
    margin-top: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_job/index.vue